import { onBeforeMount, type Ref, ref } from 'vue';

import { getConfig } from '@/core/lib/Config';

interface UseMarque {
  marqueName: Ref<string | null>;
}

function useMarque(): UseMarque {
  const marqueName = ref<string | null>(null);

  onBeforeMount(async () => {
    const config = await getConfig();

    if (config.marque) {
      marqueName.value = config.marque;
    }
  });

  return {
    marqueName,
  };
}

export default useMarque;
